<template>
  <div
    v-if="notificationStore.notifications.length"
    class="fixed bottom-4 left-1/2 z-[1000] -translate-x-1/2 transform tablet:max-w-[80%] laptop:translate-x-[calc(-50%+128px)]"
    data-testid="ui-notifications"
  >
    <MessageBanner
      v-for="notification in notificationStore.notifications"
      :key="notification.id"
      role="alert"
      :type="notification.type"
      :headline="notification.headline"
      :message="notification.message"
      class="mt-2"
    >
      <template #action>
        <div class="ml-2 flex items-end gap-2">
          <template v-for="action in notification.actions" :key="action.title">
            <p
              class="btn-link-neutral-s-underline text-inherit"
              data-testid="ui-notification-action"
              @click="handleAction(notification.id, action.handler)"
            >
              {{ action.title }}
            </p>
          </template>
          <XIcon
            v-if="notification.closeable"
            class="lucide-icon-m cursor-pointer"
            data-testid="ui-notification-close"
            @click="handleClose(notification.id)"
          />
        </div>
      </template>
    </MessageBanner>
  </div>
</template>

<script setup lang="ts">
import { MessageBanner } from '@ramp106/omrjs-core-ui'
import { XIcon } from '@ramp106/omrjs-core-ui/icons'

import { useNotificationStore } from '@/stores'

const notificationStore = useNotificationStore()

const handleClose = (notificationId: number | undefined) => {
  if (notificationId) {
    notificationStore.removeNotification(notificationId)
  }
}

const handleAction = (notificationId: number | undefined, handler: () => void) => {
  handleClose(notificationId)
  handler()
}
</script>
